import * as yup from 'yup';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service/translations/name-space.types';
import { useLocale } from '@gov-nx/core/service/translations/useLocale';
import { emailTldValidator } from './Validator/email';
import type {
	DefaultStringSchema,
	EmailShapeProps,
	EmailShapeWithSchemaProps,
	GenericStringSchema,
	RequiredEmailShapeProps,
	RequiredStringSchema,
} from './types/email.types';

const hasSchema = (
	props?: EmailShapeProps
): props is EmailShapeWithSchemaProps => props?.schema !== undefined;

const isRequiredWithoutSchema = (
	props?: EmailShapeProps
): props is RequiredEmailShapeProps =>
	props?.isRequired === true && props?.schema === undefined;

export const useEmailShape = () => {
	const { t } = useLocale(LocalizeNameSpaceTypes.Form);
	const invalidEmailMessage = t('validations.email-neni-ve-spravnem-tvaru');
	const defaultRequiredMessage = t('validations.email-je-povinny');

	function getEmailShape(props: RequiredEmailShapeProps): RequiredStringSchema;
	function getEmailShape(props: EmailShapeWithSchemaProps): GenericStringSchema;
	function getEmailShape(props?: EmailShapeProps): DefaultStringSchema;
	function getEmailShape(props?: EmailShapeProps) {
		const invalidShapeMessage =
			props?.invalidShapeMessage ?? invalidEmailMessage;

		if (hasSchema(props)) {
			const schema = props.schema
				.email(invalidShapeMessage)
				.test('has-tld', invalidShapeMessage, emailTldValidator);

			if (props.isRequired) {
				return schema.required(props.requiredMessage ?? defaultRequiredMessage);
			}

			return schema;
		}

		const schema = yup
			.string()
			.email(invalidShapeMessage)
			.test('has-tld', invalidShapeMessage, emailTldValidator);

		if (isRequiredWithoutSchema(props)) {
			return schema.required(props.requiredMessage ?? defaultRequiredMessage);
		}

		return schema;
	}

	return {
		getEmailShape,
	};
};
